import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';

let initialized = false;

export function initAnalytics() {
  if (initialized || !POSTHOG_KEY) {
    return;
  }
  
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    persistence: 'localStorage',
  });
  
  initialized = true;
}

export function identifyUser(userId: string, properties?: Record<string, any>) {
  if (!initialized) return;
  posthog.identify(userId, properties);
}

export function resetAnalytics() {
  if (!initialized) return;
  posthog.reset();
}

export function trackEvent(eventName: string, properties?: Record<string, any>) {
  if (!initialized) return;
  posthog.capture(eventName, properties);
}

export function trackWorkoutStarted(properties: {
  programId: string;
  programName: string;
  sessionName?: string;
  workoutIndex: number;
}) {
  trackEvent('workout_started', properties);
}

export function trackWorkoutCompleted(properties: {
  programId: string;
  programName: string;
  sessionName?: string;
  workoutIndex: number;
  durationSeconds?: number;
  exerciseCount?: number;
  setCount?: number;
}) {
  trackEvent('workout_completed', properties);
}

export function trackProgramCreated(properties: {
  programId: string;
  programName: string;
  sessionCount: number;
  isPrivate: boolean;
  source?: 'scratch' | 'copy' | 'import';
}) {
  trackEvent('program_created', properties);
}

export function trackExerciseLogged(properties: {
  programId: string;
  exerciseName: string;
  setNumber: number;
  trackingType?: 'strength' | 'time' | 'cardio';
}) {
  trackEvent('exercise_logged', properties);
}

export function trackSignupCompleted() {
  trackEvent('signup_completed', {});
}
